// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.sidebar-checkbox[data-v-24fd8a98] {\n    line-height: unset;\n    margin: auto;\n}\n", ""]);
// Exports
module.exports = exports;
